import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dyufggjqdw: FaireBrandEntity = {
  token: "b_dyufggjqdw",
  type: "brand",
  name: "Think Sweet",
  avatarUrl:
    "https://cdn.faire.com/fastly/7c2336fb6c90eeb1fd0d6fa2621ee02631346ed35a410bd589c8faa560a09837.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c978f6c17fc643b2eb72b2abb6a5acd670916f2bc7c46e437873e9c6a20abf0d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/7c2336fb6c90eeb1fd0d6fa2621ee02631346ed35a410bd589c8faa560a09837.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c978f6c17fc643b2eb72b2abb6a5acd670916f2bc7c46e437873e9c6a20abf0d.png",
  location: "Farmington Hills, MI, USA",
  minimumOrderDollars: 100,
  rating: 4.6,
  reviewCount: 223,
  isInsider: true,
  description:
    "Think Sweet is a family-owned brand dedicated to bringing fun, trending, and impulse-driving products to retailers nationwide. From viral toys to unique candy and novelty items, we focus on products that excite customers and generate repeat sales. Our customers’ satisfaction comes first—we pride ourselves on responsive service, fast communication, reliable fulfillment, and building long-term partnerships with the retailers we serve. When you succeed, we succeed.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:04.820Z",
    importedBy: "entity-db-cli",
  },
};
